import { Box, Typography } from "@mui/material"
import type { ReactElement } from "react"

interface ProductOriginGridHeaderProps {
  address: string | null
  testIdPrefix?: string
}

export const ProductOriginGridHeader = ({ address, testIdPrefix }: ProductOriginGridHeaderProps): ReactElement => {
  return address ? (
    <Box className='col-span-3 flex items-center border-l px-2 py-4' data-testid={`${testIdPrefix}-address-label`}>
      <Typography variant='body2' className='font-medium text-gray-700'>
        Address
      </Typography>
    </Box>
  ) : (
    <>
      <Box className='flex items-center border-l px-2 py-4' data-testid={`${testIdPrefix}-country-label`}>
        <Typography variant='body2' className='font-medium text-gray-700'>
          Country
        </Typography>
      </Box>
      <Box className='flex items-center border-none px-2 py-4' data-testid={`${testIdPrefix}-region-label`}>
        <Typography variant='body2' className='font-medium text-gray-700'>
          State/Region
        </Typography>
      </Box>
      <Box className='flex items-center border-none px-2 py-4' data-testid={`${testIdPrefix}-city-label`}>
        <Typography variant='body2' className='text-gray-700'>
          City
        </Typography>
      </Box>
    </>
  )
}
